<template>
    <PageStyleComponent :key="mainComponentKey" :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader">
        <template v-slot:body>
            <div class="mt-6">
                <div class="flex text-left mb-6">
                    <div class="basis-1/4">
                        <table class="text-left">
                            <tr>
                                <td class="font-semibold">Selected Date: </td>
                                <td> &#123;&#123; selected_date &#125;&#125;</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Particulars: </td>
                                <td> &#123;&#123; particulars &#125;&#125;</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Particulars Amount: </td>
                                <td> &#123;&#123; particulars_amount &#125;&#125;</td>
                            </tr>
                            <tr>
                                <td class="font-semibold">Txn No: </td>
                                <td> &#123;&#123; txn_no &#125;&#125;</td>
                            </tr>
                        </table>
                    </div>
                    <div class="basis-1/2">
                        <div class="w-1/2 mb-2">
                            <label for="">Template Name:<em>*</em></label>
                            <input v-model="templateName" type="text" :class="`bg-slate-50 rounded pl-3 border border-gray-400 text-base w-full`"/>
                        </div>
                        <div class="w-1/2 mb-2">
                            <label for="">Subject:<em></em></label>
                            <input v-model="templateSubject" type="text" :class="`bg-slate-50 rounded pl-3 border border-gray-400 text-base w-full`"/>
                        </div>
                        <div class="w-1/2 mb-2">
                            <label for="">File/Attachment Name:<em></em></label>
                            <input v-model="templateFileName" type="text" :class="`bg-slate-50 rounded pl-3 border border-gray-400 text-base w-full`"/>
                        </div>
                        <div>
                            <label for="">Attachment:<em></em></label>
                            <input type="text" name="" class="rounded border-2 border-gray-600 text-gray-500 text-sm pl-2 mr-2 mb-4 w-80" placeholder="" v-model="filePath" >
                            <input type="file" name="file-input" @change="onFileChange" id="file-input" accept="*/*">
                        </div>
                        <div class="basis-1/3">
                            <div class="flex-1 basis-full px-2 mt-6">
                                <button @click="saveTemplate" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Save</button>
                                <button @click="handleReset" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-refresh text-xs mr-1.5" aria-hidden="true"></i>Reset</button>
                            </div>
                        </div>
                    </div>
                    <div class="basis-1/4">
                    </div>
                </div>
                <div class="flex min-h-[550px]">
                    <div class="basis-1/4">
                        
                        <div class="w-full">
                            <table class="text-left">                         
                                <h2 class="text-center font-bold uppercase mt-4 mb-4">Company</h2>
                                <tr>
                                    <td class="font-semibold">Company Name: </td>
                                    <td> &#123;&#123; company_name &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Email: </td>
                                    <td> &#123;&#123; company_email &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Phone No: </td>
                                    <td> &#123;&#123; company_phone_number &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Address: </td>
                                    <td> &#123;&#123; company_address &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Town: </td>
                                    <td> &#123;&#123; company_town &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Country: </td>
                                    <td> &#123;&#123; company_country &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Company Tax Pin: </td>
                                    <td> &#123;&#123; company_kra_pin &#125;&#125;</td>
                                </tr>
                            </table>
                        </div>
                        <div class="w-full" v-if="sale_client_management">
                            <table class="text-left">  
                                <h2 class="text-center font-bold uppercase mb-4 mt-4">Sale Lead</h2>
                                <tr>
                                    <td class="font-semibold">Lead Name: </td>
                                    <td> &#123;&#123; lead_name &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Lead Phone No: </td>
                                    <td> &#123;&#123; lead_phone_number &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Lead Email: </td>
                                    <td> &#123;&#123;lead_email &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Lead Address: </td>
                                    <td> &#123;&#123; lead_address &#125;&#125;</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">Lead Company Name: </td>
                                    <td> &#123;&#123; lead_company_name &#125;&#125;</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="basis-1/2 text-left">
                        <quill-editor :key="editorComponentKey" v-model:value="templateContent"></quill-editor>
                    </div>
                    <div class="basis-1/4 pl-6">
 
                    </div>
                </div>
            </div>
        </template>
    </PageStyleComponent>
</template>

<script>
import { defineComponent, ref, onBeforeMount, onMounted, computed, watch } from 'vue';
import PageStyleComponent from '@/components/PageStyleComponent.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { quillEditor } from 'vue3-quill'

export default defineComponent({
    name: 'Design_Email_Template',
    components:{
        PageStyleComponent, quillEditor
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('none');
        const mainComponentKey = ref(0);
        const editorComponentKey = ref(0);
        const sale_client_management = ref(true);
        const errors = ref([]);
        const companyID = computed(()=> store.state.userData.company_id);
        const idField = ref('');
        const selectedTemplate = computed(()=> store.state.Crm_Email_Templates.selectedTemplate);
        const isEditing = computed(()=> store.state.Crm_Email_Templates.isEditing);
        const templateContent = ref('');
        const templateName = ref('');
        const localFile = ref(null);
        const filePath = ref('');
        const templateSubject = ref('');
        const templateFileName = ref('');

        const handleReset = async() =>{
            editorComponentKey.value += 1;
            templateContent.value = "";
            templateName.value = "";
            templateSubject.value = "";
            templateFileName.value = "";
            filePath.value = "";
            localFile.value = null;
        }
        watch([selectedTemplate], () => {
            if (selectedTemplate.value) {
                editorComponentKey.value += 1;
                templateContent.value = selectedTemplate.value.template_content;
                templateName.value = selectedTemplate.value.template_name;
                templateSubject.value = selectedTemplate.value.subject;
                templateFileName.value = selectedTemplate.value.file_name || '';
                filePath.value = selectedTemplate.value.attachment;
            }
            
        }, { immediate: true });
         
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        };

        const createTemplate = async() =>{
            showLoader();
            let formData = new FormData();
            formData.append('template_name', templateName.value);
            formData.append('subject', templateSubject.value);
            formData.append('template_content', templateContent.value);
            formData.append('attachment', localFile.value);
            formData.append('file_name', templateFileName.value);
            formData.append('company', companyID.value);

            errors.value = [];
            if(templateName.value == '' || templateContent.value == ''){
                errors.value.push('Error');
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideLoader();                 
            }else{            
                try {
                    const response = await store.dispatch('Crm_Email_Templates/createTemplate', formData);
                    if (response && response.status === 201) {
                        hideLoader();
                        toast.success('Template created successfully!');
                        handleReset();
                        mainComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while creating the Template.');
                        hideLoader();
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Template: ' + error.message);
                } finally {
                    hideLoader();
                }              
            }
        }
        const updateTemplate = async() =>{
            showLoader();
            let formData = new FormData();
            formData.append('email_template', selectedTemplate.value.crm_email_template_id);
            formData.append('template_name', templateName.value);
            formData.append('subject', templateSubject.value);
            formData.append('template_content', templateContent.value);
            formData.append('file_name', templateFileName.value);
            if (localFile.value !== null && localFile.value !== '') {
                formData.append('attachment', localFile.value);
            }
            formData.append('company', companyID.value);

            errors.value = [];
            if(templateName.value == '' || templateContent.value == ''){
                errors.value.push('Error');
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideLoader();                 
            }else{            
                try {
                    const response = await store.dispatch('Crm_Email_Templates/updateTemplate', formData);
                    if (response && response.status === 200) {
                        hideLoader();
                        toast.success('Template update successfully!');
                        handleReset();
                        mainComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while updating the Template.');
                        hideLoader();
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Template: ' + error.message);
                } finally {
                    hideLoader();
                }              
            }
        };
        const saveTemplate = () =>{
            if(isEditing.value == true){
                updateTemplate();
            }else{
                createTemplate();
            }
        };
        const onFileChange = (e) => {
            const file = e.target.files[0];
            if (file) {
                localFile.value = file;
                filePath.value = "C:\\fakepath\\" + file.name;
            }
        };
        onBeforeMount(()=>{ 
            editorComponentKey.value += 1;

        })

        return{
            saveTemplate, mainComponentKey,handleReset, loader, showLoader, hideLoader, idField,
            templateContent, templateName, templateSubject, templateFileName, editorComponentKey,sale_client_management,onFileChange, filePath
        }
    }
})
</script>

<style scoped>
em{
color: red;
}


</style>